import { getAntiForgeryToken } from 'Common/utils/Api';

function setLoading(uid, isLoading) {
    const container = document.getElementById(uid);

    if (!container) return;
    const loader = container.querySelector('.LoaderComponent');
    const inputsAndButtons = container.querySelectorAll(
        '.pointsRedemptionForm input, .pointsRedemptionForm button'
    );
    
    const buttonsOnly = container.querySelectorAll('.pointsRedemptionForm button');

    if (isLoading) {
        // show loader, disable inputs+buttons
        loader?.removeAttribute('style');
        inputsAndButtons.forEach((el) => (el.disabled = true));
    } else {
        // hide loader, enable buttons
        loader?.setAttribute('style', 'display: none');
        buttonsOnly.forEach((el) => (el.disabled = false));
    }
}

function repopulateRadioButtons(redemptionOptions = []) {
    redemptionOptions.forEach((option) => {
        // assuming option.Value is the input’s id
        const input = document.getElementById(option.Value);

        if (!input) return;
        input.disabled = option.Disabled;
        input.checked = !option.Disabled && !!option.Selected;
    });
}

export default class RewardsController {
    static onPointsRedeeming(uid, xhr) {
        xhr.setRequestHeader('RequestVerificationToken', getAntiForgeryToken());
        setLoading(uid, true);
    }

    static onPointsRedemption(uid, response = {}) {
        const { message, redemptionOptionsList: redemptionOptions, currentPointsText } = response;

        // reset the form
        const formContainer = document.getElementById(uid);
        const form = formContainer.querySelector(`.pointsRedemptionForm`);

        form?.reset();

        // show server result message
        const resultContainer = document.getElementById(`${uid}-message`)
        const resultMsg = resultContainer.querySelector(`.resultMessage`);

        if (resultMsg) {
            resultMsg.classList.remove('d-none');
            resultMsg.textContent = message;
        }

        // update radio buttons + points total
        repopulateRadioButtons(redemptionOptions);
        
        const ptsTotal = formContainer.querySelector(`.currentPointsTotal`);

        if (ptsTotal) ptsTotal.textContent = currentPointsText;

        setLoading(uid, false);
    }

    static validateForm(uid) {
        const container = document.getElementById(uid);

        if (!container) return;

        const selectedOption = container.querySelector(
            `.pointsRedemptionForm input[name="redemptionOptionId"]:checked:not(:disabled)`
        );

        const submitBtn = container.querySelector(`.pointsRedemptionForm button[type="submit"]`);

        if (submitBtn) {
            submitBtn.disabled = !selectedOption;
        }
    }
}
